
import React from 'react';
import mainContext from "../../../contexts/mainContext";
import { addBabySitterAvailableForController, deleteData, getBabySitterAvailableForController } from '../../../Controllers/AppManagement/babySitter';
import { __constants, __snackBarText, __snackBarSeverity } from '../../../constants';
import ImageTextListManager from '../common/ImageTextListManager';

export default function BabySitterAvailableFor() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Babysitter availability"
      dialogTitle="Add new baby sitter availability"
      textLabel="Availability"
      getData={getBabySitterAvailableForController}
      addData={addBabySitterAvailableForController}
      deleteData={deleteData}
      editTitle="Update availability"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}